<template>
  <div>
    <loadingCube v-if="loading" />

    <div v-else>
      <AdminModeContext v-slot="{ adminActive, adminBusy, toggleAdmin, withAdminLock }">
        <PageHeading :back="{ name:'a_timesheet_r2_select_period', params:{ company_id } }">
          <template #title>
            <router-link :to="{ name:'company_record', query:{ company_id } }">
              {{ company?.company_name }}
            </router-link>
            <br>
            <router-link :to="{ name:'a_timesheet_r2_select_period', params:{ company_id } }">
              Submit Timesheets
            </router-link>
            -> Select Site
          </template>
          <template>
            <p>
              Selected Timesheet period: {{ period }}.
              <router-link :to="{name:'a_timesheet_r2_select_period', params:{ company_id }}">
                (change)
              </router-link>
            </p>
          </template>
        </PageHeading>

        <sunset_timesheet_import_widget
            v-if="company !== null && !allSitesCompleted"
            prefix="a"
            :company_id="company_id"
            :end_date="end_date"
            :start_date="start_date"
            :timesheet_template_name="company.timesheet_template_name"
            :admin-mode="adminActive"
        />

        <sunset_timesheet_activity_widget
            v-if="company !== null"
            prefix="a"
            :company_id="company_id"
            :end_date="end_date"
            :start_date="start_date"
            :admin-mode="adminActive"
        />

        <div class="pane sites_container">
          <div style="display:grid;grid-template-columns:100%;grid-row-gap:1em;">
            <div style="display:grid;grid-template-columns:auto 250px 300px 170px;margin-bottom:10px;align-items:center;grid-template-rows: 40px;grid-column-gap: 1em;">
              <h2>Timesheets by site</h2>
              <h3>
                {{items.length}} sites <span v-if="search">({{ filteredItems.length }} filtered)</span>
              </h3>
              <input
                  :disabled="adminActive"
                  v-model="search"
                  style="width: 100%; height: 40px;border-radius: 4.75px;"
                  placeholder="Search by name, ID, order job ref…"
                  type="text"
              />
              <AdminToggleButton
                  :active="adminActive"
                  :toggle-admin="toggleAdmin"
                  :disabled="adminBusy"
              />
            </div>
          </div>

          <transition name="in-out">
          <div style="display: grid; grid-auto-flow: column; grid-template-columns: minmax(200px, max-content); justify-items: flex-start;grid-column-gap: 1em;">
            <div class=" header-panel" v-if="adminActive">
              <label class="filter-label">Admin actions</label>
              <div class="filter-panel__admin-actions">
                <AdminDismissAllSitesButton
                    :company-id="company_id"
                    :period="period"
                    :admin-busy="adminBusy"
                    :with-admin-lock="withAdminLock"
                    :success="init"
                    v-if="isGod()"
                />
                <AdminReopenAllSitesButton
                    :company-id="company_id"
                    :period="period"
                    :admin-busy="adminBusy"
                    :with-admin-lock="withAdminLock"
                    :success="init"
                    :hard="allPaid"
                    v-if="isGod()"
                />
                <AdminResetAllSitesButton
                    :company-id="company_id"
                    :period="period"
                    :admin-busy="adminBusy"
                    :with-admin-lock="withAdminLock"
                    :success="init"
                    :hard="allPaid"
                    v-if="isGod()"
                />
              </div>
            </div>
          </div>
          </transition>

          <!-- ROWS -->
          <ul class="location-list">
            <li v-for="item in filteredItems" class="location-row" :key="item.site_id">
              <!-- unchanged rows -->
              <div
                  class="expand-glyph"
                  @click.stop="toggleSiteDetail(item.site_id)"
                  tabindex="0"
                  :aria-expanded="!!expandedSites[item.site_id]"
              >
                <span :class="{ expanded: !!expandedSites[item.site_id] }">▶</span>
              </div>

              <div class="address">
                <router-link
                    :to="{
                    name:'a_timesheet_r2_select_site_worker',
                    params:{ company_id, start_date, end_date, order_id:item.order_id, order_job_id:item.order_job_id }
                  }"
                >
                  {{ item.short_site_name }}: {{ item.address }}
                </router-link>
              </div>

              <div class="summary-metrics">
                <template v-if="['paid', 'completed'].includes(item.min_status_name)">
                  <RadialMetric :value="(item.total_pay_amounts_by_status?.total || 0) - (item.total_pay_amounts_by_status?.paid || 0) | currency"  label="Due (£)" type="text" color="#36a266"/>
                  <RadialMetric :value="item.total_pay_amounts_by_status?.paid | currency" label="Paid (£)" type="text" color="#36a266"/>
                  <RadialMetric :value="paidPercentage(item)" label="Closed (%)" color="#36a266" />
                </template>
                <template v-else>
                  <RadialMetric :value="awaitingPercentage(item)" label="New" color="#f0ad4e" />
                  <RadialMetric :value="inProgressPercentage(item)" label="Saved" color="#f0ad4e" />
                  <RadialMetric :value="completedPercentage(item)" label="Done" color="#4297d7" />
                </template>
              </div>

              <div class="status-metrics">
                <StatusTrafficLight :status-name="item.min_status_name"/>
              </div>

              <div class="location_buttons">
                <router-link
                    key="user-buttons"
                    v-if="!adminActive"
                    :to="{
                    name:'a_timesheet_r2_select_site_worker',
                    params:{ company_id, start_date, end_date, order_id:item.order_id, order_job_id:item.order_job_id }
                  }"
                >
                  <button class="btn orcaBtn">
                    {{ item.completed ? 'View' : 'Manage' }}
                  </button>
                </router-link>
                <div key="admin_buttons" class="location_buttons" v-else>
                      <AdminReopenSiteButton
                          :company-id="company_id"
                          :site-id="item.site_id"
                          :period="period"
                          :admin-busy="adminBusy"
                          :with-admin-lock="withAdminLock"
                          :success="init"
                          v-if="item.min_status_name === 'completed'"
                      />
                      <AdminResetSiteButton
                          :company-id="company_id"
                          :site-id="item.site_id"
                          :period="period"
                          :admin-busy="adminBusy"
                          :with-admin-lock="withAdminLock"
                          :success="init"
                          v-if="item.min_status_name === 'completed'"
                      />
                      <AdminReopenSiteButton
                          :company-id="company_id"
                          :site-id="item.site_id"
                          :period="period"
                          :admin-busy="adminBusy"
                          :with-admin-lock="withAdminLock"
                          :success="init"
                          :hard="true"
                          v-if="item.min_status_name === 'paid'"
                      />
                      <AdminResetSiteButton
                          :company-id="company_id"
                          :site-id="item.site_id"
                          :period="period"
                          :admin-busy="adminBusy"
                          :with-admin-lock="withAdminLock"
                          :success="init"
                          :hard="true"
                          v-if="item.min_status_name === 'paid'"
                      />
                </div>
              </div>

              <transition name="expand">
                <div
                    v-if="expandedSites[item.site_id]"
                    class="detail-panel"
                    style="grid-column: 1 / -1; margin-top: 2em;"
                >
                  <div class="detail-cols">
                    <div>
                      <strong>Site & Order Details</strong>

                      <table class="detail-meta-table">
                        <tr>
                          <td>Site Id</td>
                          <td>{{item.site_id}}</td>
                        </tr>
                        <tr>
                          <td>Address:</td>
                          <td>{{ item.address }}</td>
                        </tr>
                        <tr>
                          <td>Building:</td>
                          <td>{{ item.job_address_building || '-' }}</td>
                        </tr>
                        <tr>
                          <td>City / Town:</td>
                          <td>{{ item.job_address_city_town || '-' }}</td>
                        </tr>
                        <tr>
                          <td>Postcode:</td>
                          <td>{{ item.job_address_postcode || '-' }}</td>
                        </tr>
                        <tr>
                          <td>Main Contractor:</td>
                          <td>
                            <strong>{{ item.site_main_contractor || '-' }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Order Location Ref:</td>
                          <td>{{ item.order_location_ref || '-' }}</td>
                        </tr>
                      </table>


                    </div>

                    <div>
                      <strong>Status / Value Breakdown</strong>
                      <table class="detail-table">
                        <thead>
                        <tr>
                          <th>Status</th>
                          <th>Count</th>
                          <th style="text-align:right;">Value</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr><td>Awaiting</td><td>{{ item.awaiting_count }}</td><td>{{ item.total_pay_amounts_by_status?.awaiting | currency }}</td></tr>
                        <tr><td>In progress</td><td>{{ item.inprogress_count }}</td><td>{{ item.total_pay_amounts_by_status?.in_progress | currency }}</td></tr>
                        <tr><td>Submitted</td><td>{{ item.workers_submitted }}</td><td>{{ item.total_pay_amounts_by_status?.submitted | currency }}</td></tr>
                        <tr><td>Finalised</td><td>{{ item.completed_count }}</td><td>{{ item.total_pay_amounts_by_status?.completed | currency }}</td></tr>
                        <tr><td>Paid</td><td>{{ item.total_paid }}</td><td>{{ item.total_pay_amounts_by_status?.paid | currency }}</td></tr>
                        </tbody>
                        <tfoot>
                        <tr>
                          <th>Total</th>
                          <th></th>
                          <th style="text-align:right;">{{ item.total_pay_amounts_by_status?.total | currency }}</th>
                        </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div>
                      <strong>Status Range</strong>
                      <table class="detail-meta-table">
                        <tr>
                          <td>Min Status:</td>
                          <td>
                            <strong>{{ item.min_status_name || '-' }}</strong>
                            <span style="color:#777;">(code {{ item.min_status_code }})</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Max Status:</td>
                          <td>
                            <strong>{{ item.max_status_name || '-' }}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Total Assignments:</td>
                          <td>{{ item.total_assignments }}</td>
                        </tr>
                        <tr>
                          <td>Total Timesheets:</td>
                          <td>{{ item.total_timesheets }}</td>
                        </tr>
                      </table>
                    </div>

                    <div>
                      <strong>Active Order Jobs</strong>

                      <table
                          v-if="item.active_order_jobs && item.active_order_jobs.length"
                          class="detail-table"
                          style="margin-top: .4em;"
                      >
                        <thead>
                        <tr>
                          <th>Order ID</th>
                          <th>Job ID</th>
                          <th>Ref</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="job in item.active_order_jobs"
                            :key="job.order_job_id"
                        >
                          <td>{{ job.order_id }}</td>
                          <td>{{ job.order_job_id }}</td>
                          <td><strong>{{ job.order_job_ref }}</strong></td>
                        </tr>
                        </tbody>
                      </table>

                      <div
                          v-else
                          style="font-size: 13px; color: #777; margin-top: .4em;"
                      >
                        No active order jobs
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
          </ul>
        </div>
      </AdminModeContext>
      <!-- Certification -->
      <div
          v-if="!allSitesCompleted"
          class="pane page_heading"
      >
        <div class="submit_all_button_container" style="margin-top: 2em;margin-bottom: 2em;">
          <button
              :disabled="saving"
              class="btn orcaBtn"
              @click="submitAllSites"
          >
            <span v-if="!saving">Finalise All Sites For Period {{ dateFormat(start_date) }} - {{ dateFormat(end_date) }}</span>
            <span v-else>Saving...</span>
          </button>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import RadialMetric from '../components/shared/RadialMetric.vue';
import StatusTrafficLight from '../components/shared/StatusTrafficLight.vue';
import loadingCube from "loaders/record_loader.vue";
import PageHeading from "../components/shared/PageHeading.vue";
import Sunset_timesheet_import_widget from "../components/shared/timesheet_import.vue";

import AdminModeContext from "../components/shared/AdminModeContext.vue";
import AdminToggleButton from "../components/shared/AdminToggleButton.vue";
import AdminDismissAllSitesButton from "pages/sunset/timesheets/admin/components/AdminDismissAllSitesButton.vue";
import AdminResetAllSitesButton from "pages/sunset/timesheets/admin/components/AdminResetAllSitesButton.vue";
import AdminReopenAllSitesButton from "pages/sunset/timesheets/admin/components/AdminReopenAllSitesButton.vue";
import AdminResetSiteButton from "pages/sunset/timesheets/admin/components/AdminResetSiteButton.vue";
import AdminReopenSiteButton from "pages/sunset/timesheets/admin/components/AdminReopenSiteButton.vue";

import sunset_timesheet_activity_widget from "./components/sunset_timesheet_activity_widget.vue";

import { dateFormat, isForeman, isGod } from "pages/sunset/timesheets/components/shared";

export default {
  components: {
    StatusTrafficLight,
    RadialMetric,
    AdminModeContext,
    AdminToggleButton,
    AdminDismissAllSitesButton,
    AdminResetAllSitesButton,
    AdminReopenAllSitesButton,
    AdminResetSiteButton,
    AdminReopenSiteButton,
    Sunset_timesheet_import_widget,
    PageHeading,
    loadingCube,
    sunset_timesheet_activity_widget
  },

  props: {
    company_id: { required: true },
    start_date: { required: true },
    end_date: { required: true },
  },

  data() {
    return {
      terms_agreed: false,
      period: this.end_date,
      loading: false,
      saving: false,
      items: [],
      search: "",
      company: null,
      expandedSites: {}, // expanded row tracking
    };
  },

  async beforeMount() {
    await this.init();
  },

  async activated() {
    await this.init();
  },

  computed: {
    summaryMinStatus() {
      if (!this.filteredItems.length) {
        return 'unknown';
      }

      const priority = [
        'awaiting',
        'in progress',
        'submitted',
        'completing',
        'completed',
        'paid',
      ];

      return this.filteredItems
          .map(i => i.min_status_name)
          .sort((a, b) => priority.indexOf(a) - priority.indexOf(b))[0];
    },
    summaryAccentColor() {
      if (!this.items.length) return '#6c757d'; // empty / neutral
      if (this.filteredItems.length !== this.items.length) return '#17a2b8';
      return '#28a745';
    },
    summaryTotals() {
      const items = this.filteredItems || [];

      let totalAssignments = 0;
      let totalCompleted   = 0;
      let totalInProgress  = 0;
      let totalAwaiting  = 0;

      let totalMoney       = 0;
      let totalPaid        = 0;

      items.forEach(item => {
        totalAssignments += item.total_assignments || 0;
        totalCompleted   += item.completed_count || 0;
        totalInProgress  += item.inprogress_count || 0;
        totalAwaiting  += item.awaiting_count || 0;

        totalMoney += item.total_pay_amounts_by_status?.total || 0;
        totalPaid  += item.total_pay_amounts_by_status?.paid || 0;
      });

      return {
        completedPct: totalAssignments > 0
            ? Math.round((totalCompleted / totalAssignments) * 100)
            : 0,

        awaitingPct: totalAssignments > 0
            ? Math.round((totalAwaiting / totalAssignments) * 100)
            : 0,

        inProgressPct: totalAssignments > 0
            ? Math.round((totalInProgress / totalAssignments) * 100)
            : 0,

        paidPct: totalMoney > 0
            ? Math.round((totalPaid / totalMoney) * 100)
            : 0,

        dueAmount: totalMoney - totalPaid,
        paidAmount: totalPaid,
      };
    },

    someSitesCompleted() {
      return (this.items?.some(i => i.completed) ?? true);
    },

    allSitesCompleted() {
      return (this.items?.every(i => i.completed) ?? true);
    },

    allExpanded() {
      // Returns true if all currently filtered rows are expanded
      if (!this.filteredItems.length) return false;
      return this.filteredItems.every(i => this.expandedSites[i.site_id]);
    },

    allPaid() {
      return this.items?.every(i =>
          i.max_status_name === 'paid' && i.min_status_name === 'paid'
      );
    },

    somePaid() {
      if(this.company_id === 7178 || this.company_id === 7579){
        return true;
      }
      return this.items?.every(i =>
          i.max_status_name === 'paid'
      );
    },

    filteredItems() {
      const q = this.search.toLowerCase().trim();
      if (!q) return this.items;
      return this.items.filter(item => {
        // Search all active_order_jobs fields
        let orderJobMatches = false;
        if (item.active_order_jobs && item.active_order_jobs.length) {
          orderJobMatches = item.active_order_jobs.some(job =>
              (job.order_job_ref && job.order_job_ref.toLowerCase().includes(q)) ||
              (job.order_id && String(job.order_id).includes(q)) ||
              (job.order_job_id && String(job.order_job_id).includes(q))
          );
        }
        const fullName = `
          ${item.short_site_name}
          ${item.job_address_building}
          ${item.job_address_street}
          ${item.job_address_city_town}
          ${item.job_address_locality}
          ${item.job_address_county}
          ${item.job_address_postcode}
          ${item.address}
          ${item.order_id}
          ${item.order_job_id}
        `.toLowerCase();
        return fullName.includes(q) || orderJobMatches;
      });
    },
  },

  methods: {
    dateFormat,
    isForeman,
    isGod,

    awaitingPercentage(item) {
      const total = item.total_assignments || 0;
      const awaiting = item.awaitingcount || 0;

      return total > 0
          ? Math.round((awaiting / total) * 100)
          : 0;
    },

    inProgressPercentage(item) {
      const total = item.total_assignments || 0;
      const inProgress = item.inprogress_count || 0;

      return total > 0
          ? Math.round((inProgress / total) * 100)
          : 0;
    },

    completedPercentage(item) {
      return item.completion_percentage || 0;
    },

    paidPercentage(item) {
      const total = item.total_pay_amounts_by_status?.total || 0;
      const paid  = item.total_pay_amounts_by_status?.paid || 0;

      return total > 0
          ? Math.round((paid / total) * 100)
          : 0;
    },

    isNotForemanRole() {
      return !this.isForeman();
    },

    toggleSiteDetail(siteId) {
      this.$set(this.expandedSites, siteId, !this.expandedSites[siteId]);
    },

    toggleExpandAll() {
      if (this.allExpanded) {
        // Contract all
        this.filteredItems.forEach(i => this.$set(this.expandedSites, i.site_id, false));
      } else {
        // Expand all
        this.filteredItems.forEach(i => this.$set(this.expandedSites, i.site_id, true));
      }
    },

    async init() {
      this.loading = true;
      await this.fetchSupportingData();
      await this.fetchSites();
      this.loading = false;
    },

    async fetchSupportingData() {
      const result = await axios.get(this.crmApiPath + 'company/' + this.company_id);
      if (result.status !== 200) {
        console.error('Could not fetch company');
        return;
      }
      this.company = result.data;
    },

    async fetchSites(page = 1) {
      let result = await axios.get(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/sites?submission_date=${this.period}`)

      if (result.status !== 200) {
        console.error('Could not fetch sites');
        return;
      }
      this.items = result.data.data;
    },

    async submitAllSites() {
      let result = await axios.post(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/submit_all?&submission_date=${this.period}`)

      if (result.status !== 200) {
        console.error('Could not submit all sites');
        return;
      }
      await this.init();
    },
  }
}
</script>

<style lang="scss" scoped>
div {
  border: none;
  background-color: inherit;
  border-radius: 10px;
}

button.actionButton{
  width: 150px;
  max-width: 150px;
}

div.location_buttons {
  display: grid;
  grid-template-columns: 100%;
  grid-auto-rows: 40px;
  grid-row-gap: 10px;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-content: center;
}

div.location_buttons button {
  width: 100%;
  min-width: 100%;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 1em;
}

ul.location-list {
  min-width: 250px;
  font-size: 16px;
  font-weight: bold;
  list-style: none;
  padding: 0;
  margin: 1em 0 0;
}

ul.location-list > li.location-row {
  display: grid;
  grid-template-columns: 20px 1fr 1fr 170px 170px;
  grid-template-rows: minmax(200px, 1fr);
  grid-column-gap: 16px;
  margin-bottom: 10px;
  border-top: thin solid lightgray;
  padding-top: 12px;
  padding-bottom: 12px;
  align-items: center;
  overflow-x: auto;
}

.location-header{
  align-content: flex-start;
}

.expand-glyph {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  font-size: 18px;
  color: #888;
  margin-right: 2px;
  transition: color 0.15s;
}
.expand-glyph:hover, .expand-glyph:focus {
  color: #444;
  outline: none;
}
.expand-glyph span {
  display: inline-block;
  transform: rotate(0deg);
  transition: transform 0.15s cubic-bezier(.5,0,.5,1);
}
.expand-glyph span.expanded {
  transform: rotate(90deg);
}

.paid {
  color: white;
  background-color:  #36a266;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

.some-paid {
  color: white;
  background-color: lightgreen;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

.in-progress {
  color: white;
  background-color: lightgreen;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

.submitted {
  color: white;
  background-color: #36a266;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

div.address {
  display: grid;
  align-content: flex-start;
  justify-content: flex-start;
  word-break: break-word;

  a{
    color: #010101;
  }
}
.workers-subtext {
  font-size: 12px;
  color: #4297d7;
  font-weight: 600;
  margin-top: 1px;
  margin-bottom: 4px;
  letter-spacing: 0.05em;
}

.detail-panel {
  //background: #f7f7fa;
  //border: 1px solid #e0e0e0;
  //border-radius: 12px;
  margin-top: 10px;
  padding: 1.3em 1.2em 1.1em 1.2em;
  font-size: 14px;
  animation: detailin .32s cubic-bezier(.72,0,.21,1);
}

@keyframes detailin {
  0% { opacity:0; transform: translateY(-8px);}
  100% { opacity:1; transform: none;}
}

.detail-cols {
  display: grid;
  grid-template-columns: minmax(250px, 1fr) minmax(250px, 1fr);
  grid-column-gap: 1.5em;
  grid-row-gap: 1.5em;
}

.detail-table, .detail-meta-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: .4em;
  margin-bottom: .2em;
  font-size: 13px;
}
.detail-table th, .detail-table td,
.detail-meta-table td {
  border-bottom: 1px solid #e0e0e0;
  padding: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}
.detail-table th {
  background: #f0f0f4;
  font-weight: 700;
  text-align: left;
}
.detail-table tfoot th {
  background: #e7e7ef;
  font-weight: 700;
  text-align: left;
}
.detail-table td, .detail-meta-table td {
  font-weight: 400;
  color: #444;
}

@media(max-width: 900px) {
  .detail-cols {
    grid-template-columns: 1fr;
    grid-gap: 0.5em;
  }
}

div.submit_all_button_container {
  display: grid;
  width: 100%;
  justify-content: center;
  align-content: center;
}


.summary-header-metrics {
  padding-bottom: 1em;
  padding-top: 1em;
}

.summary-metrics {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 30px;
  align-content: center;
  justify-content: flex-end;
  height: 100%;
}

.status-metrics {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 30px;
  align-content: center;
  justify-content: center;
  height: 100%;
}

.filter-bar {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto;
  column-gap: 16px;
  align-items: center;
  min-height: 40px;
}

.filter-bar__search {
  max-width: 420px;
}

.filter-bar__actions {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  column-gap: 10px;
  justify-content: flex-end;
}

.header-panel {
  display: grid;
  min-width: 400px;
  grid-template-columns: 100%;
  grid-template-rows: 35px 1fr;
  justify-content: flex-start;
}

.filter-panel__top {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 20px;
  align-items: center;
}

.filter-panel__top > button {
  white-space: nowrap;
}

.filter-panel__admin-actions {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  grid-auto-columns: max-content;
  justify-content: flex-start;
}

.filter-panel__divider {
  height: 1px;
  background: #e6e6e6;
  margin: 20px 0;
}

.filter-panel__bottom {
  display: grid;
  row-gap: 6px;
}

.filter-label {
  font-size: 11px;
  font-weight: 600;
  color: #777;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.15s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
}


</style>
